
import { defineComponent, ref, computed } from "vue";
import { useRoute } from "vue-router";
import Form from "./Form.vue";
import ChangeLogTable from "@/components/change_logs/ChangeLogTable.vue";

export default defineComponent({
  components: {
    Form,
    ChangeLogTable,
  },
  setup() {
    const route = useRoute();
    const activeTab = ref("info");
    const userId = computed(() => Number(route.params.id));

    return {
      activeTab,
      userId,
    };
  },
});
